/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import * as React from "react";
import { CheckIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage } from "@/i18n/useLanguage";

export function LanguageDropdown() {
	const { t } = useTranslation();
	const { languages, current, changeLanguage } = useLanguage();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				{/* On phones the trigger becomes a 44px circular chip so it reads as a
				    deliberate pair with the menu button and clears the minimum touch
				    target; from `md` (where the desktop nav takes over) the original
				    pill is restored untouched. */}
				<Button
					variant="outline"
					aria-label={t("languageSwitcher.label")}
					className="touch-target h-11 w-11 rounded-full p-0 shadow-[0_4px_16px_rgba(12,16,32,0.18)] md:h-9 md:w-auto md:rounded-md md:px-4 md:py-2 md:shadow-xs">
					<span className="mr-0 lg:mr-2">
						<img
							src={current.flag}
							alt={current.label}
							className="w-5 h-5"
						/>
					</span>
					<span className="hidden lg:inline">{current.nativeName}</span>
				</Button>
			</DropdownMenuTrigger>

			<DropdownMenuContent
				align="end"
				className="w-52">
				{languages.map((lang) => (
					<DropdownMenuItem
						key={lang.code}
						onClick={() => changeLanguage(lang.code)}
						className="flex items-center justify-between gap-2 cursor-pointer">
						<div className="flex items-center gap-2">
							<img
								src={lang.flag}
								alt={lang.label}
								className="w-5 h-5 shrink-0"
							/>
							<span className="flex flex-col leading-tight">
								<span>{lang.nativeName}</span>
								<span className="text-[11px] text-muted-foreground">
									{lang.label}
								</span>
							</span>
						</div>

						{current.code === lang.code && (
							<CheckIcon className="size-4 shrink-0" />
						)}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
